import * as React from "react";
import { AboutModal, Text, TextContent, TextList, TextListItem } from "@patternfly/react-core";

import ShoutOut from "../assets/brands/Shoutout-Logo2.png";
import AltronBrand from "../assets/images/AltronLogoLight.png";
import NetstarBrand from "../assets/images/netstar logo-02.png";

export const AboutModalComponent = ({ isOpen, toggleOpen }) => {
  let tennantLogo = AltronBrand;
  const host = window.location.hostname;

  if (host.includes("netstar")) {
   tennantLogo = NetstarBrand;
  };
  

  return (
    <AboutModal
      isOpen={isOpen}
      onClose={(e) => toggleOpen(e)}
      trademark="&copy; Copyright Altron 2025"
      backgroundImageSrc={tennantLogo}
      brandImageSrc={ShoutOut}
      brandImageAlt="Company Logo"
      productName="ShoutOuts"
      hasNoContentContainer={false}
      style={{ backgroundPosition: 'center'}}
    >
      <TextContent>
        <Text component="p">
          Giving employees and fellow team members recognition for their hard work is a great way to let them 
          feel valued and appreciated in the workplace, which encourages them to perform at their best and
          increases productivity. The ShoutOut Application is designed to make recognition easy. It gets team
          members connected, engaged and shows members of the team their hard work is recognised and appreciated.
        </Text>
        <Text component="p">&nbsp;</Text>
        <TextList component="dl">
          <TextListItem component="dt">Version</TextListItem>
          <TextListItem component="dd">{ process.env.REACT_APP_VERSION }</TextListItem>
        </TextList>
      </TextContent>
    </AboutModal>
  );

};